import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';

/**
 * Full-page loading spinner component
 * Displays a centered spinner with optional loading text
 * Used as Suspense fallback while lazy-loaded components are loading
 */
const PageLoader = ({ message = "Loading..." }) => {
    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            right="0"
            bottom="0"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg="rgba(255, 255, 255, 0.95)"
            zIndex="9999"
            _dark={{
                bg: "rgba(26, 32, 44, 0.95)"
            }}
        >
            <VStack spacing={4}>
                <Spinner
                    thickness="4px"
                    speed="0.65s"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="xl"
                    w="60px"
                    h="60px"
                />
                <Text
                    fontSize="lg"
                    fontWeight="medium"
                    color="gray.600"
                    _dark={{
                        color: "gray.300"
                    }}
                >
                    {message}
                </Text>
            </VStack>
        </Box>
    );
};

export default PageLoader;
